import styled from 'styled-components';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../CommonComponents/OPL/Icon/Icon';

export const Wrapper = styled(Box)({
  display: 'flex',
  height: '100%',
});

export const CenteredContainer = styled(Box).attrs({ as: 'main' })({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  gap: 16,
});

export const BigIcon = styled(Icon).attrs({ 'aria-hidden': true })({
  fontSize: 48,
});
BigIcon.defaultProps = {
  color: 'neutral.400',
};

export const Title = styled(Text).attrs({ as: 'h1' })(({ theme }) => ({
  color: theme.colors.neutral['600'],
  fontSize: theme.fontSizes.h4,
  lineHeight: theme.lineHeights.h4,
  fontWeight: 600,
  textAlign: 'center',
}));

export const Description = styled(Text).attrs({ as: 'p' })(({ theme }) => ({
  color: theme.colors.neutral['500'],
  maxWidth: 550,
  textAlign: 'center',
}));

export const Actions = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: 235,
});
